/* BARRA DE ANUNCIOS ROTATIVA (Bloque 1) */
(function(){
  var wrap = document.getElementById('mg-topbar-msgs');
  if (!wrap) return;
  var msgs = wrap.querySelectorAll('.mg-topbar__msg');
  if (msgs.length <= 1) return;
  var i = 0;
  setInterval(function(){
    msgs[i].classList.remove('is-active');
    i = (i + 1) % msgs.length;
    msgs[i].classList.add('is-active');
  }, 3200);
})();

/* HERO SLIDESHOW */
(function(){
  var slider = document.getElementById('mg-slider');
  if (!slider) return;
  var slides = slider.querySelectorAll('.mg-slide');
  var dots = slider.querySelectorAll('.mg-sl-dot');
  var thumbStrip = document.querySelector('.mg-thumbs');
  var thumbs = document.querySelectorAll('.mg-thumb');
  var prevBtn = slider.querySelector('.mg-sl-arrow--prev');
  var nextBtn = slider.querySelector('.mg-sl-arrow--next');
  var cur = 0;
  var total = slides.length;
  var timer;

  function fitToImage() {
    var slide = slides[cur];
    if (!slide) return;
    var img = slide.querySelector('img');
    if (!img) return;
    var apply = function() {
      var w = slider.clientWidth || slider.offsetWidth;
      if (!w) return;
      var ar = (img.naturalWidth && img.naturalHeight) ? img.naturalWidth / img.naturalHeight : 1;
      var h = w / ar;
      var maxH = Math.min(window.innerHeight * 0.72, 620);
      h = Math.max(240, Math.min(h, maxH));
      slider.style.height = Math.round(h) + 'px';
    };
    if (img.complete && img.naturalWidth) apply();
    else img.addEventListener('load', apply, { once: true });
  }
  fitToImage();
  window.addEventListener('resize', fitToImage);

  if (total <= 1) {
    if (prevBtn) prevBtn.style.display = 'none';
    if (nextBtn) nextBtn.style.display = 'none';
    var dotWrap = slider.querySelector('.mg-sl-dots');
    if (dotWrap) dotWrap.style.display = 'none';
    if (thumbStrip) thumbStrip.style.display = 'none';
    return;
  }

  function go(i) {
    cur = (i + total) % total;
    slides.forEach(function(s, idx){ s.classList.toggle('is-active', idx === cur); });
    dots.forEach(function(d, idx){ d.classList.toggle('is-active', idx === cur); });
    thumbs.forEach(function(tb, idx){ tb.classList.toggle('is-active', idx === cur); });
    if (thumbStrip && thumbs[cur]) {
      var atb = thumbs[cur];
      thumbStrip.scrollTo({ left: atb.offsetLeft - (thumbStrip.clientWidth / 2) + (atb.clientWidth / 2), behavior: 'smooth' });
    }
    fitToImage();
  }
  function next(){ go(cur + 1); }
  function prev(){ go(cur - 1); }
  function loop(){ clearInterval(timer); timer = setInterval(next, 5500); }

  if (nextBtn) nextBtn.addEventListener('click', function(){ next(); loop(); });
  if (prevBtn) prevBtn.addEventListener('click', function(){ prev(); loop(); });
  dots.forEach(function(d, i){ d.addEventListener('click', function(){ go(i); loop(); }); });
  thumbs.forEach(function(tb, i){ tb.addEventListener('click', function(){ go(i); loop(); }); });
  loop();

  var startX = 0, dx = 0;
  slider.addEventListener('touchstart', function(e){ startX = e.touches[0].clientX; dx = 0; }, {passive:true});
  slider.addEventListener('touchmove',  function(e){ dx = e.touches[0].clientX - startX; }, {passive:true});
  slider.addEventListener('touchend',   function(){ if (Math.abs(dx) > 40) { if (dx < 0) { next(); } else { prev(); } loop(); } });
})();

/* REVEAL ON SCROLL */
(function(){
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.js-reveal').forEach(function(el){ el.classList.add('is-visible'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.15 });
  document.querySelectorAll('.js-reveal').forEach(function(el){ io.observe(el); });
})();
